import React, { useState } from 'react';
import ReviewSection from '../screens/resenias';
import { useNavigate } from 'react-router-dom';

const boton = {
  backgroundColor: '#f44336',
  color: '#ffffff',
  border: 'none',
  padding: '10px 20px',
  borderRadius: '8px',
  cursor: 'pointer',
  fontSize: '16px',
  boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
  transition: 'background-color 0.3s ease',
};


const FormularioResena = ({ onClose }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: '',
    titulo: '',
    resenia: '',
    calificacion: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('https://frabas.cl/backend/Resenias/CrearResenia.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        console.log('Reseña registrada correctamente');
        navigate('/');

      } else {
        setError(data.message || 'Error al registrar usuario');
      }

    } catch (err) {
      console.error(err);
      setError('Error en la conexión con el servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-4 p-4 border rounded-lg bg-gray-50 shadow">
      <h3 className="text-xl font-bold mb-4">Añadir reseña</h3>
      {error && <div className="text-red-500 mb-2">{error}</div>}
      <form onSubmit={handleSubmit}>
        <input name="nombre" value={formData.nombre} onChange={handleChange} className="block mb-2 w-full border p-2 rounded" placeholder="Tu nombre" />
        <input name="titulo" value={formData.titulo} onChange={handleChange} className="block mb-2 w-full border p-2 rounded" placeholder="Titulo" />
        <input name="resenia" value={formData.resenia} onChange={handleChange} className="block mb-2 w-full border p-2 rounded" placeholder="Escribe tu reseña aqui" />
        <input type="number" min='1' max='5' name="calificacion" value={formData.calificacion} onChange={handleChange}  className="block mb-2 w-full border p-2 rounded" placeholder="Calificacion (1-5)" />
        
        <div className="flex gap-2">
          <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded" disabled={loading} >
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
          <button type="button" onClick={onClose} className="bg-gray-400 text-white px-4 py-2 rounded">Cancelar</button>
        </div>
      </form>
    </div>
  );

};

function Resenas() {
const [mostrarFormulario, setMostrarFormulario] = useState(false);

  const toggleFormulario = () => {
    setMostrarFormulario(!mostrarFormulario);
  };

  return (
    <div className='my-10 text-lg font-semibold bg-white p-4'>
      <button style={boton} onClick={toggleFormulario}>
        {mostrarFormulario ? 'Cerrar formulario' : 'Añadir reseñas'}
      </button>

      {mostrarFormulario && <FormularioResena onClose={toggleFormulario} />}

      <ReviewSection />
    </div>
  );
}

export default Resenas;
